module.exports = __webpack_public_path__ + "img/startchat.4db79c88.png";